module.exports = __webpack_public_path__ + "img/5d234c7f381c79ad79cd70da5e6c5e72.png";